<template>
  <div>
       <v-card flat color="#F6F8FC" class="px-9">
          <div class="py-6"><b>Link to share</b></div>
          <div class="d-flex pb-9">
            <v-text-field
              v-model="shareLink"
              flat
              background-color="#E5F1EC"
              solo
              dense
              hide-details
              v-on:focus="$event.target.select()"
              ref="clone"
            ></v-text-field>
            <v-btn class="ml-2" color="#52AE32" text
              ><span
                class="text_style"
                style="letter-spacing: 0px"
                @click="copyLink"
                >Copy link</span
              ></v-btn
            >
          </div>
        </v-card>
    <!-- <v-tabs
      class="px-9"
      slider-color="#52AE32"
      color="#52AE32"
      v-model="Optiontab"
    >
      <v-tab>
        <span class="text_style" style="letter-spacing: 0px">
          Share link
        </span></v-tab
      >
      <v-tab>
        <span class="text_style" style="letter-spacing: 0px">
          By mail
        </span></v-tab
      >
    </v-tabs>
    <v-tabs-items v-model="Optiontab">
      <v-tab-item>
        <v-card flat color="#F6F8FC" class="px-9">
          <div class="py-6"><b>Link to share</b></div>
          <div class="d-flex pb-9">
            <v-text-field
              v-model="shareLink"
              flat
              background-color="#E5F1EC"
              solo
              dense
              hide-details
              v-on:focus="$event.target.select()"
              ref="clone"
            ></v-text-field>
            <v-btn class="ml-2" color="#52AE32" text
              ><span
                class="text_style"
                style="letter-spacing: 0px"
                @click="copyLink"
                >Copy link</span
              ></v-btn
            >
          </div>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat color="#F6F8FC" class="px-9 pb-10">
          <div class="py-6">
            <b>Send Survey by Mail</b>
            <span class="font-14 primary--text">(See history)</span>
          </div>
          <v-textarea
            solo
            style="border: 1px dashed #dee3ef"
            single-line
            flat
            hide-details
            name="input-7-4"
            v-model="descByMail"
          ></v-textarea>
          <div class="my-3 d-flex align-center">
            <v-checkbox v-model="checkboxByMail" dense> </v-checkbox>
            <div class="font-14 mt-2">
              <b>
                Select all students who finished their course and did not
                complete the survey
              </b>
            </div>
          </div>
          <div v-if="!checkboxByMail" class="px-4">
            <v-row
              style="border: 1px dashed #dee3ef; background: white"
              class="mt-6 align-center"
            >
              <v-col cols="1">
                <div><v-icon>mdi-account-supervisor</v-icon></div>
              </v-col>
              <v-col cols="9">
                <v-text-field
                  placeholder="Add mail"
                  single-line
                  hide-details
                  flat
                  dense
                  solo
                ></v-text-field
              ></v-col>
              <v-col cols="2">
                <v-btn color="primary" text class="ma-0 pa-0"
                  ><span class="text_style">+Add</span></v-btn
                >
              </v-col>
            </v-row>
            <v-row
              style="background: white"
              class="align-center"
              v-for="(item, i) in emailHistory"
              :key="i"
            >
              <v-col cols="1">
                <div>
                  <v-avatar size="35" v-if="item.img">
                    <img alt="Avatar" :src="item.img" />
                  </v-avatar>
                  <v-avatar :color="item.color" v-else size="35">
                    <span class="white--text">{{
                      item.userName.substring(0, 1).toUpperCase()
                    }}</span>
                  </v-avatar>
                </div>
              </v-col>
              <v-col cols="9">
                <div class="font-14 ml-3">
                  <b>{{ item.userName }}</b>
                </div>
              </v-col>
              <v-col cols="2" class="d-flex justify-center">
                <v-icon color="red" @click="closeCurrentMail(item.id)"
                  >mdi-close</v-icon
                >
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs-items> -->
    <div class="py-6 px-9 d-flex justify-end">
      <v-btn color="#A1A1A6" outlined class="px-11 mr-4" @click="close"
        ><span class="text_style">Close</span></v-btn
      >
      <v-btn
        color="primary"
        depressed
        class="px-11"
        v-if="Optiontab == '1'"
        @click="ConfirmSurveyDialog = true"
        ><span class="text_style">Send</span></v-btn
      >
    </div>
    <!---------------cofirm dialoag-------------------->
    <v-dialog v-model="ConfirmSurveyDialog" max-width="530">
      <v-card class="pa-9" color="#E5E5E5">
        <SendConfirmComponent
          :confrimsurvey="ConfirmSurveyDialog"
          @close="close"
        ></SendConfirmComponent>
        <div class="d-flex justify-center">
          <div>
            <div class="font-nuito font-14">
              This email was sent to
              <span class="primary--text"> axel@agencycoda.com </span>
            </div>
            <div class="font-nuito font-14">
              IBA Talk | contact@iba.com | [location?]
            </div>
            <div class="font-nuito font-14">
              Copyright © 2021 IBA Talk. All rights reserved.
            </div>
            <div
              class="font-nuito font-14 my-8 d-flex justify-center"
              style="color: #203389"
            >
              Poweredy by Agencycoda
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SendConfirmComponent from "./sendconfirm.component.vue";
export default {
  name: "SendSurveyComponent",
  components: { SendConfirmComponent },
  props: ["sendsurvey"],

  data() {
    return {
      ConfirmSurveyDialog: false,
      checkboxByMail: false,
      descByMail:
        "[message_mail] Lorem ipsum dolor sit amet consectetur adropising Lorem ipsum dolor sit amet consectetur adropising Lorem ipsum dolor sit amet consectetur adropising Lorem ipsum dolor sit amet consectetur adropising",
      Optiontab: null,
      shareLink: "https://drive.google.com/drive/folders/1omZ1lIXQc1asd4",
      emailHistory: [
        {
          img: "https://avatars0.githubusercontent.com/u/9064066?v=4&s=460",
          userName: "Darlene Robertson",
          color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
          id: 0,
        },
        {
          img: "https://avatars0.githubusercontent.com/u/9064066?v=4&s=460",
          userName: "Savannah Nguyen",
          color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
          id: 1,
        },
        {
          userName: "cody-fisher@gmail.com",
          color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
          id: 2,
        },
      ],
    };
  },
  methods: {
    closeCurrentMail(id) {
      this.emailHistory = this.emailHistory.filter((x) => x.id != id);
    },
    copyLink() {
      this.$refs.clone.focus();
      document.execCommand("copy");
    },
    close() {
      this.$emit("close");
      this.ConfirmSurveyDialog = false;
    },
  },
};
</script>

<style scoped>
.font-14 {
  font-size: 14px;
}
.font-nuito {
  font-family: "Nunito";
}
</style>
